import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { Icon } from "../../icon/icon";

export const TicketReservationExpiredModal = ({
  open,
  handleClose,
}: ModalCompProps) => {
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      className="!max-w-[460px] !p-0"
      dialogClassName="!my-0"
      showHeader={false}
    >
      <div className="relative flex justify-center bg-blue-bg pt-[42px]">
        <img
          src="/assets/images/tikket-phone.png"
          alt="welcome"
          className="h-auto w-full max-w-[300px]"
        />

        <button
          type="button"
          className="absolute right-3.5 top-3.5 flex h-[36px] w-[36px] items-center justify-center rounded-full bg-white text-grey-950"
          onClick={handleClose}
        >
          <Icon svg="close-icon" width={20} height={20} className="" />
        </button>
      </div>

      <div className="flex flex-col gap-4 p-5">
        <p className="font-fraunces text-2xl tracking-[-4%]">
          Ticket Reservation Has Expired
        </p>

        <p className="text-base font-normal text-gray-900">
          Your ticket reservation has expired because the reservation time has
          expired. Please, start again to buy tickets.
        </p>

        <Button
          type="button"
          text="Okay"
          onClick={handleClose}
          className="mt-2"
        />
      </div>
    </ModalComponent>
  );
};
